module.exports = __webpack_public_path__ + "img/CM-NL-24-Volkswagen-Lifestyle.e0feda27.jpg";